import { combineReducers } from "redux";
import { Login } from "./login";
import { Batches } from "./RBatches";
import { Branches } from "./RBranches";
import { Courses } from "./RCources";
import { CourseByEvents } from "./RCourseByEvents";
import { Coursereg } from "./RCoursereg";
import { Users } from "./RUsers";
import { Events } from "./REvents";
import { Teachers } from "./RTeachers";
import { WeekDays } from "./RWeekDays";
import { Level } from "./RLevels";
import { PayuPayment } from "./RPayuPayment";
import { OnlineClass } from "./ROnlineclass";

export const rootReducer = combineReducers({
  login: Login,
  users: Users,
  batches: Batches,
  courses: Courses,
  branches: Branches,
  coursereg: Coursereg,
  events: Events,
  teachers: Teachers,
  weekDays: WeekDays,
  level: Level,
  payuPayment: PayuPayment,
  onlineClass: OnlineClass,
  courseByEvents: CourseByEvents,
});
